<div class="container-fluid p-0 m-0">
  <div class="card border-0 p-0 m-0">
    <div class="card-header-marron text-center">
      <img src='/assets/images/100x.png' class="p-3" style="height: 120px;width: 140px;">
    </div>
    <div class="card-body p-2 " style="background: white !important; border-radius: 5px;">
      <div class="card" style="background: white !important; border-radius: 5px;box-shadow: 0 0 1px rgba(0,0,0,.125),0 1px 3px rgba(0,0,0,.2);">
        <div class="card-header">
          Chat with us
        </div>
        <div class="card-body p-0 " style="background: white !important;">
          <div (click)="depositSupport()" class="p-2 border border-bottom border-secondary border-left-0 border-top-0 border-right-0">
            <h6 style="color: #3a4b67;">Deposit Support</h6>
            <p class="mb-0" style="color:darkgray">🙏 WELCOME TO 100xwins</p>
          </div>
          <div class="p-2 border border-bottom border-secondary border-left-0 border-top-0 border-right-0">
            <h6 (click)="withdrawSupport()" style="color: #3a4b67;">Withdraw Support</h6>
            <p class="mb-0" style="color:darkgray">🙏 WELCOME TO  100xwins</p>
          </div>
          <div class="p-2 border border-bottom border-secondary border-left-0 border-top-0 border-right-0">
            <h6 (click)="techSupport()" style="color: #3a4b67;">Signup Support & Other Support</h6>
            <p class="mb-0" style="color:darkgray">Hello, let us know if you need any help related to signup 😀</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  <div class="d-flex justify-content-between">-->
  <!--    <h3 class="text-warning">Bet Slip</h3>-->
  <!--    <span (click)="closeDialog()" class="material-symbols-outlined">close</span>-->
  <!--  </div>-->
</div>
